'use client';

import { c as _c } from "react/compiler-runtime";
import { app, nativeWindow } from '@todesktop/client-core';
import { useEffect } from 'react';
import { clientLogger } from '@/lib/client-logger';

/**
 * Keeps the desktop app in the tray when the computer starts it at login: the main window hides
 * itself and the tray icon brings it back. It runs once per launch of the app, so reloading the
 * window later does not hide it again. Only macOS reports a launch at login.
 */
export function DesktopStartInTray() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp3, t0);
  return null;
}
function _temp3() {
  app.once("start-in-tray", _temp).catch(_temp2);
}
function _temp2(error) {
  clientLogger.error("Failed to start the desktop app in the tray", error);
}
async function _temp() {
  const {
    wasOpenedAtLogin
  } = await app.getLoginItemSettings();
  if (wasOpenedAtLogin) {
    await nativeWindow.hide();
  }
}